import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-logged-out',
  imports: [MatButton],
  templateUrl: './logged-out.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logged-out.component.scss',
})
export class LoggedOutComponent implements OnInit {
  constructor(private readonly authService: AuthenticationService) {}

  async ngOnInit(): Promise<void> {
    await this.authService.completeLogoutRedirect();
  }

  async login(): Promise<void> {
    await this.authService.login();
  }
}
